import { TimeAgo } from '@/components/time-ago';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

const columnHelper = createColumnHelper<CampaignResponse>();

export const getCampaignsTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('id', {
      id: 'id',
      header: () => t('campaign:table.id'),
      cell: ({ row }) => <p>{row.original.id}</p>,
      minSize: 400,
      maxSize: 400,
      meta: {
        className: () => 'text-sm text-tertiary-600',
      },
    }),
    columnHelper.accessor('name', {
      id: 'name',
      header: () => t('campaign:table.campaign'),
      cell: ({ row }) => <p>{row.original.name}</p>,
      minSize: 200,
      maxSize: 200,
      meta: {
        className: () => 'text-sm text-tertiary-600',
      },
    }),
    columnHelper.accessor('createdOn', {
      id: 'createdOn',
      header: () => t('campaign:table.createdAt'),
      cell: ({ getValue }) => <TimeAgo time={getValue()} format='yyyy-MM-dd' />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    // columnHelper.display({
    //   id: 'size',
    //   header: () => t('campaign:table.totalUsers'),
    //   cell: ({ row }) => <CampaignTotalUsersColumn campaign={row.original} />,
    //   minSize: 150,
    //   maxSize: 150,
    //   meta: {
    //     className: () => 'font-semibold',
    //     align: 'center',
    //     nestedClassName: () => 'w-full flex',
    //   },
    // }),
  ] as ColumnDef<CampaignResponse>[];
